// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cb5457b7","239":"940a4d69","667":"57fe8ff8"}[chunkId] + ".chunk.js";
};